import React, { Component } from 'react';
import PageHeader from '../../components/page-header';
import { map } from 'lodash';
import './style.scss';
import { Favorite, Room } from '@material-ui/icons';

export default class index extends Component {

    componentDidMount() {
        console.log(this.props.location.state);
    }

    render() {
        return (
            <div className='borrower-info'>
                <PageHeader text='Borrower info' history={this.props.history} />

                <div className="borrower-data">
                    <div className="avatar" style={{ background: `#fff url('${this.props.location.state.borrower.picture}') no-repeat center`, backgroundSize: 'cover' }} />
                    <div className="borrower-details">
                        <div className="name"><span>{this.props.location.state.borrower.name}</span>Pet borrower</div>
                        <div className='location'>
                            <Room /> {this.props.location.state.borrower.location}
                        </div>
                        <div className='looking-for'>
                            <label> Looking for:</label>
                            {
                                map(this.props.location.state.borrower.looking_for, looking_for => (
                                    <span className='borrower-availabity' key={looking_for}>{looking_for}</span>
                                ))
                            }
                        </div>
                        <div className='experiance'>
                            <label> Experiance:</label>
                            {
                                map(this.props.location.state.borrower.experiance, experiance => (
                                    <span className='borrower-availabity' key={experiance}>{experiance}</span>
                                ))
                            }
                        </div>
                        <div className='availablity'>
                            <label> Available on:</label>
                            {
                                map(this.props.location.state.borrower.availablity, availabity => (
                                    <span className='borrower-availabity' key={availabity}>{availabity}</span>
                                ))
                            }
                        </div>
                        <div className="description">{this.props.location.state.borrower.description}</div>
                        <div className="controls">
                            <a href={`tel:${this.props.location.state.borrower.contact_number}`} className="link-button" >Contact {this.props.location.state.borrower.name}</a>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

